import { render, staticRenderFns } from "./WizardPageGenerateCsr.vue?vue&type=template&id=a3c0871e&scoped=true&"
import script from "./WizardPageGenerateCsr.vue?vue&type=script&lang=ts&"
export * from "./WizardPageGenerateCsr.vue?vue&type=script&lang=ts&"
import style0 from "./WizardPageGenerateCsr.vue?vue&type=style&index=0&id=a3c0871e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3c0871e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
